import { SafeResourceUrl } from '@angular/platform-browser';

export interface UploadedFile {
  fileData: File;
  extension?: string;
  url?: string;
  urlSafe?: SafeResourceUrl;
}

export const availableExtensions = ['pdf', 'jpg', 'jpeg', 'png'];
